import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ag, cl } from '@fullcalendar/core/internal-common';
import { AgentsService } from 'src/app/core/services/agents/agents.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';

@Component({
  selector: 'app-common-popup',
  templateUrl: './common-popup.component.html',
  styleUrls: ['./common-popup.component.scss']
})
export class CommonPopupComponent implements OnInit {
  passwordResetForm = this._fb.group({
    password: [''],
    confirmPassword: [''],
  });
  constructor(
      public dialogRef: MatDialogRef<CommonPopupComponent>,
      @Inject(MAT_DIALOG_DATA) public agentData: any,
      private _fb: FormBuilder,
      private _toster: ToasterService,
      private _agentService: AgentsService,
  ) {}

  ngOnInit(): void {
      console.log(this.agentData);
  }

  close(){
      this.dialogRef.close(true);
  }

  generatePassword({
    length = 12,
    includeUppercase = true,
    includeLowercase = true,
    includeNumbers = true,
    includeSpecial = true
  } = {}) {
    // Define character sets
    const uppercaseChars = 'ABCDEFGHJKLMNPQRSTUVWXYZ'; // Removed confusing chars like I and O
    const lowercaseChars = 'abcdefghijkmnopqrstuvwxyz'; // Removed confusing chars like l
    const numberChars = '23456789'; // Removed confusing chars like 0 and 1
    const specialChars = '!@#$%^&*()-_=+[]{};:,.<>?';
    
    // Create a pool of available characters based on options
    let charPool = '';
    if (includeUppercase) charPool += uppercaseChars;
    if (includeLowercase) charPool += lowercaseChars;
    if (includeNumbers) charPool += numberChars;
    if (includeSpecial) charPool += specialChars;
    
    // Handle edge case: no character types selected
    if (!charPool) {
      throw new Error('At least one character type must be selected');
    }
    
    // Initialize password and tracking variables
    let password = '';
    let hasUppercase = !includeUppercase;
    let hasLowercase = !includeLowercase;
    let hasNumber = !includeNumbers;
    let hasSpecial = !includeSpecial;
    
    // Generate password
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charPool.length);
      const char = charPool[randomIndex];
      password += char;
      
      // Track character types
      if (uppercaseChars.includes(char)) hasUppercase = true;
      if (lowercaseChars.includes(char)) hasLowercase = true;
      if (numberChars.includes(char)) hasNumber = true;
      if (specialChars.includes(char)) hasSpecial = true;
    }
    
    // Ensure password meets complexity requirements
    // If we're missing a required character type, regenerate the password
    if ((includeUppercase && !hasUppercase) || 
        (includeLowercase && !hasLowercase) || 
        (includeNumbers && !hasNumber) || 
        (includeSpecial && !hasSpecial)) {
      return this.generatePassword({length, includeUppercase, includeLowercase, includeNumbers, includeSpecial});
    }
    return password;
  }

  generatePass() {
    const password = this.generatePassword({
      length: 16,
      includeUppercase: true,
      includeLowercase: true,
      includeNumbers: true,
      includeSpecial: true
    });
    console.log(password);
    this.passwordResetForm.patchValue({
      password: password,
      confirmPassword: password
    });
  }

  updatePassword(){
    const password = this.passwordResetForm.get('password')?.value;
    const cnfpassword = this.passwordResetForm.get('confirmPassword')?.value;
    if(password === '' || cnfpassword === ''){
      this._toster.showSwalError('Sorry!','Password cannot be empty');
      return;
    }
    if(password !== cnfpassword){
      this._toster.showSwalError('Sorry!','Password does not match');
      return;
    }
    if (password) {
      let payload = {
        "id": this.agentData?.agentData?.id,
        "tenantId": this.agentData?.agentData?.tenantId,
        "userType":"agent", 
        "password":password,
        "confirmpassword":password
      }
      this._agentService.resetAgentPassword(payload)
      .subscribe((res)=>{
        navigator.clipboard.writeText(password).then(() => {
          // console.log('Password copied to clipboard');
          this._toster.showSwalSuccess('Success','Password copied to clipboard');
          this.close();
          // close();
          }).catch(err => {
          // console.error('Failed to copy password: ', err);
          });
      })
      
    } else {
      // console.error('No password to copy');
    }
  }

}
